import { createFileRoute } from '@tanstack/react-router'
import { BackupsOverview } from '@/features/backups/overview'

export const Route = createFileRoute('/_authenticated/backups/')({
  component: BackupsOverview,
})

